import http from "utilities/http-common";
import { AxiosResponse } from "axios";

const baseUrl = '/api/settings';

export async function getVertrouwelijk(): Promise<boolean> {
    return http.get(baseUrl + '/vertrouwelijk')
        .then((resp: AxiosResponse<boolean>) => {
            return resp.data;
        });
}

export async function getSettings(tenantId?: string): Promise<setting> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }
    return http.get(baseUrl, { params })
        .then((resp: AxiosResponse<setting>) => {
            return resp.data;
        });
}

export async function getEmailNames(tenantId: string): Promise<{ [key: string]: string }> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }
    return http.get(baseUrl + '/email-names', { params })
        .then((resp: AxiosResponse<any>) => {
            return resp.data;
    });
}

export async function downloadEmail(name: string, tenantId: string): Promise<Blob> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }
    return http.get(`${baseUrl}/email-download/${name}`, { params, responseType: 'blob' })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });

}

export async function downloadFile(file: 'aanvraag' | 'attest' | 'vertrouwelijk', tenantId?: string): Promise<Blob> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }
    return http.get(`${baseUrl}/download/${file}`, { params, responseType: 'blob' })
        .then((resp: AxiosResponse<Blob>) => {
            return resp.data;
        });
}

export async function updateSettings(settings: setting): Promise<setting> {
    return http.post(`${baseUrl}`, settings)
        .then((resp: AxiosResponse<setting>) => {
            return resp.data;
        });
}

export async function updateVertrouwelijk(enabled: boolean, tenantId: string): Promise<setting> {
    const params = new URLSearchParams();
    params.append('enabled', enabled.toString());
    params.append('tenantId', tenantId.toString());

    return http.post(`${baseUrl}/vertrouwelijk`, params, {params: params})
        .then((resp: AxiosResponse<setting>) => resp.data);
}

export async function updateConnective(enabled: boolean, tenantId?: string): Promise<setting> {
    const params = new URLSearchParams();
    params.append('enabled', enabled.toString());

    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http.post(`${baseUrl}/connective`, params, {params: params})
        .then((resp: AxiosResponse<setting>) => resp.data);
}

export interface setting {
    useVertrouwelijk: boolean;
    useConnective: boolean;
    mailSetting: mailSettings;
    tenantId?: string;
}

interface mailSettings {
    defaultFromAddress: string;
}